import React from "react";

import { Stack, Typography } from "@mui/material";

import { buildEmailMailtoLink } from "@app/analytics/account/Billing/utils";
import type { User } from "@app/common/types";
import type { EnterpriseWorkspaceUser } from "@app/common/workspaces/types";

import Link from "@rui/Link";

const NonAdminCurrentPlanContent = ({
  workspaceOwner,
  user,
}: {
  workspaceOwner: EnterpriseWorkspaceUser;
  user: User;
}) => {
  return (
    <Stack spacing={1}>
      <Typography variant="bodyPrimaryReg" sx={{ color: "shades.neutral.600" }}>
        You are in a Workspace-managed plan.
      </Typography>
      <Typography
        variant="bodySecondaryReg"
        sx={{ color: "shades.neutral.600" }}
      >
        Contact your Workspace owner{" "}
        {workspaceOwner && (
          <>
            (
            <Link
              href={buildEmailMailtoLink(workspaceOwner, user)}
              sx={{ fontWeight: "400", textDecoration: "underline" }}
            >
              {workspaceOwner.email}
            </Link>
            ){" "}
          </>
        )}
        to adjust plans or billing.
      </Typography>
    </Stack>
  );
};

export default NonAdminCurrentPlanContent;
